import React from 'react'
import { Item } from '../../../../common/snippets'
import { Box, Button } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import DemurrageChrgTable from './DemurrageChrgTable'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import * as mdt from '../../../../common/modaltypes'
import DemurrageChrgModal from './DemurrageChrgModal'
import { useState } from 'react'
import { useEffect } from 'react'
import { focusElemnt, isEmpty, navigation3 } from '../../../../common/helper'
import { bookingType, chargeType } from '../../GSConstants'
import { PaymentTypesOptions } from '../../../../common/constants'
import { getDemurrageChrg, updateDemurrageChrg } from '../../../../../store/generalSetting/GSAction'
import ConfirmModal from './ConfirmModal'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const DeliveryCharges = (props) => {
  const {
    data: { common },
    updateModal,
    updateAlertError,
    getDemurrageChrg,
    updateDemurrageChrg,
  } = props
  const { loginData, showModal, modalType, cnsgnmntTypes,companySettings } = common
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const mapTranslated = (list = []) =>
    list.map((item) => ({ ...item, name: tr(item.translationKey, item.name) }))
  const translatedBookingTypes = mapTranslated(bookingType)
  const translatedChargeTypes = mapTranslated(chargeType)
  const consignmentTypesWithAll = cnsgnmntTypes.length > 0
    ? [{ ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') }, ...cnsgnmntTypes]
    : []
  const paymentTypeOptions = (PaymentTypesOptions || []).map((item) => {
    if (item.id === 0) {
      return { ...item, Name: tr('gsAll', 'All') }
    }
    if (UseToPayAsCOD === 1) {
      if (item.id === 2) {
        return { ...item, Name: 'COD' };
      }
      if (item.id === 7) {
        return { ...item, Name: 'COD Manual' };
      }
      if (item.id === 9) {
        return { ...item, Name: 'COD DDDV' };
      }
      if (item.id === 4) {
        return null;
      }
    }
    return item;
  }).filter(Boolean)
  const [selConsignmentType, setSelConsignmentType] = useState({ ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') })
  const [selBookingType, setSelBookingType] = useState(bookingType[0])
  const [selChargeType, setSelChargeType] = useState(chargeType[0])
  const [selPaymentType, setSelPaymentType] = useState({ id: 0, Name: tr('gsAll', 'All') })
  const [reportData, setReportData] = useState([])
  useEffect(() => {
    focusElemnt('Booking_Type')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getDemurrageChrgList()
    }
  }, [loginData])
  useEffect(() => {
    setSelBookingType((prev) => translatedBookingTypes.find((item) => item.id === prev?.id) || translatedBookingTypes[0])
    setSelChargeType((prev) => translatedChargeTypes.find((item) => item.id === prev?.id) || translatedChargeTypes[0])
    setSelConsignmentType((prev) =>
      consignmentTypesWithAll.find((item) => item.ConsignmentSubTypeID === prev?.ConsignmentSubTypeID) || prev
    )
    setSelPaymentType((prev) => paymentTypeOptions.find((item) => item.id === prev?.id) || prev)
  }, [translations])
  const addDemurrageChrgModal = () => {
    const propsData = {
      isUpdate: false,
      headText: tr('gsAddDemChg', 'Add Demurrage Charge'),
    }
    return <DemurrageChrgModal UseToPayAsCOD={UseToPayAsCOD} propsData={propsData} getDemurrageChrgList={getDemurrageChrgList} />
  }
  const getDemurrageChrgList = () => {
    setReportData([])
    if (selConsignmentType === '' || selConsignmentType === ' ') {
      updateAlertError({ show: true, msg: tr('gsSelCnsErr', 'Please Select Consignment Type'), nextId: 'Select_Consignment_Type' })
    } else {
      const body = {
        CompanyID: loginData?.intCompanyID,
        BookingType: selBookingType?.id,
        ChargeType: selChargeType?.id,
        ConsignmentType: selConsignmentType?.ConsignmentSubTypeID,
        PaymentType: selPaymentType?.id,
      }
      getDemurrageChrg(body)
        .then((res) => {
          if (res.status === 'Success') {
            const updatedData = res.Data.Table?.map((val) => ({
              ...val,
              PaymentType:
                UseToPayAsCOD === 1 && val.PayTypeID === 2
                  ? tr('gsCod', 'COD')
                  : val.PayTypeID === 7
                    ? tr('gsCodManual', 'COD Manual')
                    : val.PayTypeID === 9
                      ? tr('gsCodDddv', 'COD DDDV')
                      : val.PaymentType,
            }))
            setReportData(updatedData)
          } else {
            updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Consignment_Type' })
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    }
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
        <Box sx={{ display: 'flex' }} className="itemButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              key={`booking-filter-${language}-${selBookingType?.name}`}
              id={'Booking_Type'}
              label={tr('gsBookType', 'Booking Type')}
              data={translatedBookingTypes}
              defaultvalue={selBookingType?.name}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              nextId={'Charge_Type'}
              onSelect={(val) => {
                setSelBookingType(val)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }}>
            <DropDownOA
              key={`charge-filter-${language}-${selChargeType?.name}`}
              id={'Charge_Type'}
              label={tr('gsChgType', 'Charge Type')}
              data={translatedChargeTypes}
              idKey={`id`}
              dataKey={`name`}
              defaultvalue={selChargeType?.name}
              minWidth="250px"
              nextId={'Select_Consignment_Type'}
              prevId={`Booking_Type`}
              onSelect={(val) => {
                setSelChargeType(val)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              key={`consignment-filter-${language}-${selConsignmentType?.SubType}`}
              id={'Select_Consignment_Type'}
              label={tr('gsSelCnsType', 'Select Consignment Type')}
              data={consignmentTypesWithAll}
              defaultvalue={selConsignmentType?.SubType || selConsignmentType}
              value={selConsignmentType?.SubType || selConsignmentType}
              onSelect={(val) => {
                setSelConsignmentType(val)
              }}
              idKey={`ConsignmentSubTypeID`}
              dataKey={`SubType`}
              minWidth="250px"
              prevId={`Charge_Type`}
              nextId={'Payment_Type'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingLeft: '12px' }}>
            <DropDownOA
              key={`payment-filter-${language}-${selPaymentType?.Name}`}
              id={'Payment_Type'}
              label={tr('gsPayType', 'Payment Type')}
              // data={PaymentTypesOptions}
              data={paymentTypeOptions}
              defaultvalue={selPaymentType?.Name}
              value={selPaymentType?.Name}
              dataKey={`Name`}
              idKey={`id`}
              minWidth="250px"
              nextId={'load_btn'}
              prevId={`Select_Consignment_Type`}
              onSelect={(val) => {
                setSelPaymentType(val)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
            <Button
              variant="contained"
              id={'load_btn'}
              sx={{ paddingY: '7px !important', height: '37px' }}
              className="btn btn-primary"
              onClick={getDemurrageChrgList}
              onKeyDown={(e) => navigation3(e, 'new_add_btn', 'Payment_Type', () => {})}
            >
              {tr('gsLoad', 'Load')}
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id={'new_add_btn'}
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.deliveryChrgModal)
              }}
              onKeyDown={(e) => navigation3(e, 'Booking_Type', 'load_btn', () => {})}
            >
              {tr('gsAddNewDem', '+ ADD NEW DEMURRAGE CHARGES')}
            </Button>
          </Item>
        </Box>
      </Box>
      <Box sx={{ marginTop: '15px' }}>
        <DemurrageChrgTable
          UseToPayAsCOD={UseToPayAsCOD}
          updateModal={updateModal}
          reportData={reportData}
          showModal={showModal}
          modalType={modalType}
          cnsgnmntTypes={cnsgnmntTypes}
          loginData={loginData}
          updateAlertError={updateAlertError}
          getDemurrageChrgList={getDemurrageChrgList}
        />
      </Box>
      {showModal && mdt.deliveryChrgModal === modalType ? addDemurrageChrgModal() : null}
      {showModal && mdt.demurrageChrgConfModal === modalType ? <ConfirmModal updateModal={updateModal} /> : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError, getDemurrageChrg, updateDemurrageChrg }
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryCharges)
